import { Fragment, useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Badge, Typography, makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import EditOrderModal from "../../EditOrderModal";
import { useDispatch } from "react-redux";

let zones = [
    {
        name: '温哥华',
        start_lng: -123.347295
    },
    {
        name: '埃德蒙顿',
        start_lng: -113.982821
    },
    {
        name: '温尼伯',
        start_lng: -97.415688
    },
    {
        name: '滑铁卢',
        start_lng: -80.628259
    },
    {
        name: '汉密尔顿',
        start_lng: -80.255193
    },
    {
        name: '多伦多',
        start_lng: -79.6298610000
    },
    {
        name: '渥太华',
        start_lng: -76.359212
    },
    {
        name: '蒙特利尔',
        start_lng: -73.957589
    },
    {
        name: '哈利法克斯',
        start_lng: -63.687034
    }
];

let deliveryTypes = [
    {
        subscribe: 1,
        type: '预约单'
    },
    {
        subscribe: 2,
        type: '火箭送'
    },
    {
        subscribe: 4,
        type: '夜宵送'
    }
]

let paidHtml = "[刷卡已过]";
let unpaidHtml = "[刷卡未过暂缓分配]";

function OrderDetails(props) {
    const { order } = props;
    const dispatch = useDispatch();

    const [orderItem, setOrderItem] = useState({});
    const [expand, setExpand] = useState(false);
    const [zone, setZone] = useState('温哥华');
    const [deliveryType, setDeliveryType] = useState('非预约单');
    const [pindanTitle, setPindanTitle] = useState('');
    const [payTitle, setPayTitle] = useState('');
    const [catName, setCatName] = useState('');
    const [goTitle, setGoTitle] = useState("已用时：");
    const [consigneeTitle, setConsigneeTitle] = useState('');
    const [totalFee, setTotalFee] = useState(0);
    const [acceptTile, setAcceptTile] = useState(0);
    const [tno, setTno] = useState('');
    const [editOrderModalOpen, setEditOrderModalOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);

    function _handleExpandAccordion(event, expanded) {
        setExpand(expanded)
    }
    function handleEditOrderModalOpen(tno) {
        setTno(tno);
        setEditOrderModalOpen(true);
    }
    function handleEditModalClose() {
        setEditOrderModalOpen(false);
    }

    useEffect(() => {
        if(order) {
            setOrderItem(order);
            setExpanded(false);
        }
    }, [order])
    useEffect(() => {
        if(orderItem) {
            zones.map((zone) => {
                if(orderItem.lng > zone.start_lng) {
                    setZone(zone.name)
                }
            })
            let exist = false;
            deliveryTypes.map((item) => {
                if(item.subscribe === orderItem.is_subscribe) {
                    exist = true;
                    setDeliveryType(item.type);
                }
            })
            if(!exist) {
                setDeliveryType('非预约单 ');
            }
            if(orderItem.pindan === 1) {
                setPindanTitle('[拼单]');
            }
            if((orderItem.pay_id === 3) ||
            (orderItem.pay_id === 8 && orderItem.partner_id !== 2) ||
            (orderItem.pay_status === 2)) {
                setPayTitle(paidHtml);
            } else {
                setPayTitle(unpaidHtml);
            }
            if(orderItem.partner_shop_name !== null) {
                setCatName(orderItem.partner_shop_name)
            } else {
                setCatName(orderItem.cat_name)
            }
            let currTime = new Date();
            currTime = (currTime.getTime()) / 1000;
            let goMinutes = parseInt(currTime - orderItem.add_time) / 60;
            if (goMinutes < 25) {
                setGoTitle("已用时:" + parseInt(goMinutes) + "min");
            } else {
                setGoTitle("已用时:" + parseInt(goMinutes) + "min");
            }
            if(orderItem.is_vip === 0) {
                setConsigneeTitle('客户名：');
            } else {
                setConsigneeTitle('VIP名：');
            }
            setTotalFee((parseFloat(orderItem.money_paid) + parseFloat(orderItem.order_amount)).toFixed(2));
            if(orderItem.shop_accept > 0) {
                setAcceptTile('已经点餐');
            } else {
                setAcceptTile('还没点餐');
            }
        }
    }, [orderItem])

    return (
        <Fragment>
        {
            order &&
            <div>
                <EditOrderModal 
                    open={editOrderModalOpen} 
                    tno={tno}
                    tnoType='order_id'
                    onClose={handleEditModalClose} 
                    handleClose={handleEditModalClose} 
                    byResendOrder={true} 
                />
                <Accordion 
                    style={{width: '450px'}}
                    onChange={_handleExpandAccordion}
                >
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography 
                            style={{
                                fontWeight: 'bold', 
                                textTransform: 'uppercase'
                            }}
                        >
                            <div
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: '360px'
                                }}
                            >
                                大区：{zone} [{catName}]
                            </div>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div 
                            style={{
                                display: 'flex', flexDirection:'column'
                            }}
                        >
                            <div style={{fontWeight: 900}}>大区：{zone}</div>
                            <div>
                                <span style={{color: '#03A9F4'}}>[{deliveryType}]</span>
                                <span>{payTitle}</span>
                            </div>
                            <div>城市：{orderItem.pin_label}{orderItem.shop_area_name}</div>
                            <div>[{catName}]{pindanTitle}{orderItem.partner_name}</div>
                            <div>晚单时间：{orderItem.receive_time_label}</div>
                            <div>[{goTitle}]</div>
                            <div style={{color: '#03A9F4'}}>{consigneeTitle}{orderItem.consignee}</div>
                            <div>
                                <span>[订单总额：${totalFee}]</span>
                                <span style={{color: '#FF3D00'}}>[{acceptTile}]</span>
                            </div>
                            <div style={{display: 'flex', marginTop: 10}}>
                                <Button 
                                    variant='contained'
                                    color="primary"
                                    onClick={() => {
                                        setExpanded(!expanded)
                                    }}
                                >
                                    {
                                        expanded ? 
                                        '收起详情' :
                                        '展开详情'
                                    }
                                </Button>
                                <Button
                                    variant='contained'
                                    color="secondary"
                                    style={{marginLeft: 20}}
                                    onClick={()=>{
                                        handleEditOrderModalOpen(orderItem.order_id)
                                    }}
                                >
                                    编辑订单
                                </Button>
                            </div>
                            {
                                expanded &&
                                <div
                                    style={{
                                        display: 'flex', 
                                        flexDirection:'column',
                                        marginTop: 20,
                                        padding: 10,
                                        borderRadius: 10,
                                        backgroundColor: '#ff9800',
                                        color: '#33230c',
                                        fontSize: '0.8rem',
                                        width: '350px'
                                    }}
                                >   
                                    <div style = {{ display: 'flex' }}>
                                        <div>订单号：</div>
                                        <div style={{overflowX: 'auto'}}>{orderItem.order_sn}</div>
                                    </div>
                                    <div style = {{ display: 'flex', marginTop: 5 }}>
                                        <div>收件人：</div>
                                        <div style={{overflowX: 'auto'}}>{orderItem.consignee}</div>
                                    </div>
                                    <div style = {{ display: 'flex', marginTop: 5 }}>
                                        <div>地址：</div>
                                        <div style={{overflowX: 'auto'}}>{orderItem.address}</div>
                                    </div>
                                    <div style = {{ display: 'flex', marginTop: 5 }}>
                                        <div>手机号：</div>
                                        <div style={{overflowX: 'auto'}}>{orderItem.mobile}</div>
                                    </div>
                                    <div style = {{ display: 'flex', marginTop: 5 }}>
                                        <div>添加时间：</div>
                                        <div style={{overflowX: 'auto'}}>{orderItem.add_order_time}</div>
                                    </div>
                                    <div style = {{ display: 'flex', marginTop: 5, alignItems: 'center' }}>
                                        <div>状态：</div>
                                        <div style={{display: 'flex', marginTop: 5, flexWrap: 'wrap', maxWidth: '300px', fontWeight: 900}}>
                                            <div>{orderItem.pay_name}，</div>
                                            <div>{(orderItem.pay_status > 1) ? "已经付款" : "未付款"}，</div>
                                            <div>{(orderItem.is_called === 1) ? "商家已经接单" : "商家未接单"}，</div>
                                            <div>{orderItem.shipping_status === 1 ? '正在送' : (orderItem.shipping_status === 2 ? '已送达' : '')}，</div>
                                            <div>{orderItem.shipping_staff_id ? "已经分派给司机" : "没有分派给司机"}，</div>
                                            <div>{orderItem.is_read === 1 ? "司机已读" : (orderItem.is_read === 0 ?  "司机未读" : '')}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div> 
                    </AccordionDetails>
                </Accordion>
            </div>
        }
        </Fragment>
    )
}

export default OrderDetails;